import { validateName, hasStarted } from "_assets/js/helpers";

export const validatePersonalForm = (form) => {
  const isValid = {
    first_name: {
      started: hasStarted(form?.first_name),
      valid: validateName(form?.first_name || "") ? 1 : 0,
    },
    last_name: {
      started: hasStarted(form?.last_name),
      valid: validateName(form?.last_name || "") ? 1 : 0,
    },
  };

  let allValid = true;
  Object.keys(isValid).forEach((key) => {
    if (!isValid[key].valid) allValid = false;
  });
  isValid.allValid = allValid;

  return isValid;
};
